/**
 * Return rsc of actual round to show in leaderboard
 * in case lastUnit = some playoff then lastUnit = round 4
 * 
 * @param {*} lastUnit 
 * @param {*} phase 
 * @returns 
 */

export const getCurrentRound = (lastUnit, phase)  => {
    var rsc = lastUnit || phase + '000100--'
    return rsc.indexOf("RR") > -1 ? phase + '000400--' : rsc
}
